import BaseSecondaryStickyView from "scripts/views//baseSecondaryStickyNavView";
import templateModulePageNav from "templates/modulePageNav.hbs";

class ModulePageNavView extends BaseSecondaryStickyView {
  get template() {
    return templateModulePageNav;
  }
}

export default ModulePageNavView;
